import Switcher from "@components/switcher/Switcher";
import UnifiedTransactionCounterpartyDetails from "../unified_transactions/UnifiedTransactionCounterpartDetails";
import CPGLogsDetails from "./CPGLogsDetails";
import CPGOrderFlowDetails from "./CPGOrderFlowDetails";

interface CPGDetailsTabsProps {
  transactionId: number;
  merchantOrderId?: string;
}

const CPGDetailsTabs: React.FC<CPGDetailsTabsProps> = ({
  transactionId,
  merchantOrderId,
}) => {
  const tabs = [
    {
      label: "TRANSACTION",
      component: <CPGOrderFlowDetails transactionId={transactionId} />,
    },
    {
      label: "LOGS",
      component: <CPGLogsDetails transactionId={transactionId} />,
    },
    {
      label: "COUNTERPARTY",
      component: (
        <UnifiedTransactionCounterpartyDetails
          transactionId={transactionId}
          merchantOrderId={merchantOrderId}
          source="cpg"
        />
      ),
    },
  ];
  return (
    <div className="flex flex-col gap-[12px]">
      <Switcher tabs={tabs} />
    </div>
  );
};

export default CPGDetailsTabs;
